import { Head } from '@inertiajs/react';
import { Button } from '@/components/ui/button';

const Fuggir = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Head title="fuggiremovia" />
      <main className="relative min-h-screen overflow-hidden px-6 py-10">
        <div className="absolute inset-0 bg-linear-to-b from-background via-background to-muted/50" aria-hidden="true" />
        <div
          className="absolute right-[8%] top-[12%] h-96 w-96 rounded-full bg-primary/25 blur-3xl"
          aria-hidden="true"
        />
        <div className="relative mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center gap-6 text-center">
          <div className="relative">
            <div className="fuggir-halo absolute inset-0 rounded-full border border-primary/30 blur-md" aria-hidden="true" />
            <div className="relative rounded-full border border-primary/40 px-10 py-6">
              <h1>fuggiremovia</h1>
            </div>
          </div>
          <p className="text-muted-foreground">Si fugge dal caos, si va verso la calma.</p>
          <Button asChild>
            <a href="https://www.emovia.com">Scopri Emovia</a>
          </Button>
          <p className="text-muted-foreground">La distanza giusta e quella che aiuta.</p>
          <div className="rounded-full border border-border px-4 py-1">
            <p className="text-muted-foreground">Portale aperto, coordinate stabili</p>
          </div>
        </div>
      </main>
      <style>{`
        .fuggir-halo {
          animation: fuggir-halo 3s ease-in-out infinite;
        }
        @keyframes fuggir-halo {
          0% { transform: scale(0.95); opacity: 0.4; }
          50% { transform: scale(1.08); opacity: 0.75; }
          100% { transform: scale(0.95); opacity: 0.4; }
        }
        @media (prefers-reduced-motion: reduce) {
          .fuggir-halo { animation: none; }
        }
      `}</style>
    </div>
  );
};

export default Fuggir;
